<template>
  <div class="language-switch">
    <!--
    <el-button 
      size="small" 
      :type="currentLocale === 'zh-CN' ? 'primary' : 'default'"
      @click="switchLanguage('zh-CN')"
    >
      简
    </el-button>
    -->
    <el-button 
      size="small" 
      :type="currentLocale === 'en-US' ? 'primary' : 'default'"
      @click="switchLanguage('en-US')"
    >
      En
    </el-button>
    <el-button 
      size="small" 
      :type="currentLocale === 'zh-TW' ? 'primary' : 'default'"
      @click="switchLanguage('zh-TW')"
    >
      繁
    </el-button>
    <!--
    <el-button 
      size="small" 
      type="warning"
      @click="forceRefresh"
      title="如果语言切换没有生效，请点击此按钮"
    >
      <i class="el-icon-refresh"></i>
    </el-button>
    -->
  </div>
</template>

<script>
import { Loading } from 'element-ui'

export default {
  name: 'LanguageSwitch',
  data() {
    return {
      currentLocale: this.$i18n.locale
    }
  },
  methods: {
    switchLanguage(locale) {
      if (this.currentLocale === locale) {
        return // 如果语言没有变化，不执行任何操作
      }

      // 显示加载中提示
      const loadingInstance = Loading.service({
        lock: true,
        text: '语言切换中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      // 设置i18n的语言
      this.$i18n.locale = locale
      this.currentLocale = locale
      
      // 更新ElementUI的语言
      document.querySelector('html').setAttribute('lang', locale)
      
      // 保存语言选择到本地存储
      localStorage.setItem('language', locale)
      
      // 延迟关闭加载提示，给页面一点时间渲染新语言
      setTimeout(() => {
        loadingInstance.close()
        
        // 显示语言切换成功提示
        this.$message({
          message: this.$t('msg.success'),
          type: 'success',
          duration: 1500
        })
      }, 500)
    },
    
    // 强制刷新页面，解决顽固的语言切换问题
    forceRefresh() {
      const loadingInstance = Loading.service({
        lock: true,
        text: '正在刷新...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      
      setTimeout(() => {
        loadingInstance.close()
        location.reload()
      }, 500)
    }
  },
  created() {
    // 获取当前语言
    this.currentLocale = this.$i18n.locale
  }
}
</script>

<style scoped>
.language-switch {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-right: -10px;
}
</style> 


// WEBPACK FOOTER //
// src/components/LanguageSwitch.vue